import React from "react";

// The brand mark. Source art lives in public/brand/: logo.png is the original
// supplied transparent PNG (1024², artwork padded and slightly off-centre);
// logo-mark.png is that file cropped square to its artwork so it sits flush
// against the wordmark at small sizes. logo-mark-light.png is the same pixels
// recoloured to --foreground, because the gold has too little contrast against
// the light theme's cream background.
//
// Both variants ship in the markup and are swapped with Tailwind's `dark:`
// class variant rather than by reading theme state, so the correct one is
// painted on first frame — no flash of the wrong mark on load or toggle.
//
// alt="" is deliberate — every use is paired with the "GetJewelDesigns"
// wordmark, so naming the image would make screen readers say it twice.

export default function Logo({ className = "h-7 w-7" }) {
  const shared = `${className} shrink-0 select-none`;
  const src = (file) => `${process.env.PUBLIC_URL}/brand/${file}`;

  return (
    <>
      <img
        src={src("logo-mark-light.png")}
        alt=""
        width={256}
        height={256}
        decoding="async"
        className={`${shared} block dark:hidden`}
      />
      <img
        src={src("logo-mark.png")}
        alt=""
        width={256}
        height={256}
        decoding="async"
        className={`${shared} hidden dark:block`}
      />
    </>
  );
}
